import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { GodinaRacunaDropdownService } from '@kodit/core/services';
import { storageUrlClean } from '../../../../../../apps/core/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalFilterInterceptorService implements HttpInterceptor {
  constructor(
    private _godinaService: GodinaRacunaDropdownService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (!req.url.includes(storageUrlClean)) {
      req = this._godinaService.applyHeaderFilter(req);
    }

    return next.handle(req);
  }
}
